import api, { apiSetup } from '../api';

apiSetup();

export class EstadosEstudiosService {
  BASE_URL = '/estados-estudios';

  get() {
    return api.get(this.BASE_URL);
  }
}
